import React, { useMemo } from 'react';
import DataGridGenerico from "../../../components/dataGrid/DataGridGenerico";
import { formatCurrency, parsedCurrency } from '../../../utils/mathUtils';

export const GrillaLiquidacionesPaciente = ({
    totalValue,
    totalLabel = 'Total',
    columns = [],
    rows,
    ...rest
}) => {

    const summaryRow = useMemo(() => {
        if (totalValue === undefined || totalValue === null) return null;

        return {
            key: totalLabel,
            value: formatCurrency(totalValue)
        }

    }, [totalValue, totalLabel]);

    return (
        <DataGridGenerico
            columns={columns}
            rows={rows}
            summaryRow={summaryRow}
            maxHeight={267}
            {...rest}
        />
    );
}